import { TypedTypePolicies } from '../generated';

import { EtaMonitor } from './eta-monitor.type-policy';

export const OrderTask: TypedTypePolicies['OrderTask'] = {
  fields: {
    ...EtaMonitor.fields,
    arriveTimeEnd: {
      read(value: string): Date {
        return value ? new Date(value) : null;
      },
    },
    createdAt: {
      read(value: string): Date {
        return value ? new Date(value) : null;
      },
    },
  },
};
